import { useTranslation } from "react-i18next";
import styles from "../OfficeStaffInformation.module.scss";
import Text from "components/Text";
import Empty from "components/Empty";
import Loader from "components/Loader";
import defaultImage from "assets/images/staff-default.svg";
import { MoreTagsFunction } from "accountOwner/pages/AddEvent/addEvents.functions";
import InviteesPopup from "accountOwner/pages/EventDetails/components/Modals/InviteesPopup";
import { useState } from "react";

const StaffCardView = ({
  isLoading,
  staffData,
  children,
  message,
  officeListShow = null,
}) => {
  const [invitePopupOpen, setInvitePopupOpen] = useState(null);

  const { t } = useTranslation();
  if (isLoading) {
    return <Loader />;
  }
  if (!staffData?.length) {
    return <Empty Message={message || t("noStaffMemberFound")} />;
  }
  const officeListShowLength = officeListShow?.length > 1;
  const roleShowOnly = officeListShow?.length === 1;
  const officeId = officeListShow && officeListShow[0]?.id;

  return (
    <>
      <div className={styles["owner-staff-manager"]}>
        {message
          ? null
          : staffData.map((user) => {
              let userOffice = null;
              if (user?.userOffice?.length) {
                if (officeListShowLength) {
                  userOffice = user?.userOffice?.map((member) => {
                    return {
                      name: `${member?.office?.name} (${
                        member?.designation?.name || ""
                      })`,
                    };
                  });
                } else if (roleShowOnly) {
                  userOffice = user?.userOffice
                    ?.filter((res) => res?.officeId === officeId)
                    .map((member) => {
                      return {
                        name: member?.designation?.name || "",
                      };
                    });
                }
              }

              return (
                <div className={styles["office-card"]} key={user.id}>
                  <div className={styles["image"]}>
                    <img
                      src={user.profilePic ? user.profilePic : defaultImage}
                      alt=""
                      onError={(e) => {
                        e.target.src = defaultImage;
                      }}
                    />
                  </div>
                  <div className={`${styles["staff-directory-wrapper"]}`}>
                    <Text
                      color="#587E85"
                      size="16px"
                      weight="600"
                      className="text-wrap text-break"
                    >
                      {user.firstName +
                        (user?.lastName ? " " + user?.lastName : "")}
                    </Text>
                    <Text color="#6F7788" size="12px" weight="600">
                      <a
                        href={`mailto:` + user?.emailId}
                        className={`main-text-color  ${styles["company-directoty-detail"]}`}
                      >
                        <svg
                          width="18"
                          height="18"
                          viewBox="0 0 18 18"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          className="me-xxs"
                        >
                          <path
                            d="M3 15C2.5875 15 2.23438 14.8531 1.94063 14.5594C1.64688 14.2656 1.5 13.9125 1.5 13.5V4.5C1.5 4.0875 1.64688 3.73438 1.94063 3.44063C2.23438 3.14688 2.5875 3 3 3H15C15.4125 3 15.7656 3.14688 16.0594 3.44063C16.3531 3.73438 16.5 4.0875 16.5 4.5V13.5C16.5 13.9125 16.3531 14.2656 16.0594 14.5594C15.7656 14.8531 15.4125 15 15 15H3ZM15 6L9.39375 9.50625C9.33125 9.54375 9.26562 9.57188 9.19687 9.59063C9.12812 9.60938 9.0625 9.61875 9 9.61875C8.9375 9.61875 8.87188 9.60938 8.80313 9.59063C8.73438 9.57188 8.66875 9.54375 8.60625 9.50625L3 6V13.5H15V6ZM9 8.25L15 4.5H3L9 8.25ZM3 6.1875V5.08125V5.1V5.09063V6.1875Z"
                            fill="#587E85"
                          />
                        </svg>

                        <span>{user?.emailId}</span>
                      </a>
                    </Text>
                    {user?.contactNumber && (
                      <Text color="#6F7788" size="12px" weight="600" underline>
                        <a
                          href={`tel:+` + user?.contactNumber}
                          className={`main-text-color  ${styles["company-directoty-detail"]}`}
                        >
                          <svg
                            className="me-xxs"
                            width="18"
                            height="18"
                            viewBox="0 0 18 18"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M5.99131 2.25009C6.9699 2.24056 7.80436 2.95787 7.94248 3.93369C8.01106 4.45365 8.13867 4.96452 8.32139 5.4542L8.36631 5.58896C8.56618 6.26635 8.38359 7.0045 7.87901 7.51474L7.53526 7.85849L7.71885 8.12802C8.34983 9.01568 9.14017 9.78017 10.0499 10.3819L10.0753 10.3976L10.422 10.0509C10.9294 9.5492 11.667 9.36713 12.3429 9.5665L12.7745 9.71494C13.1736 9.84355 13.5847 9.93572 14.006 9.9913C14.9863 10.1297 15.707 10.9811 15.6827 11.9522V13.7491C15.6849 14.2982 15.4555 14.8232 15.0509 15.1944C14.6463 15.5654 14.1042 15.7481 13.544 15.6974C11.5812 15.4841 9.69576 14.8137 8.04502 13.7433C6.50246 12.7631 5.19456 11.4551 4.21787 9.91806C3.13988 8.25401 2.46849 6.35938 2.25791 4.37607C2.20866 3.831 2.39095 3.29008 2.75987 2.88584C3.12886 2.48161 3.65115 2.25071 4.19932 2.25009H5.99131ZM4.2003 3.75009C4.07406 3.75023 3.95342 3.80349 3.86827 3.89658C3.7832 3.98977 3.74099 4.11461 3.75108 4.22861C3.93556 5.96585 4.52628 7.6357 5.47959 9.10752C6.34174 10.4643 7.49296 11.6147 8.85557 12.4806C10.3153 13.4272 11.9764 14.0186 13.6925 14.2052C13.8186 14.2166 13.9439 14.1745 14.0372 14.089C14.1306 14.0033 14.1832 13.8818 14.1827 13.752L14.1837 11.9337C14.1894 11.7053 14.0224 11.5086 13.8028 11.4776C13.1709 11.3943 12.5502 11.2402 11.9513 11.0167C11.7869 10.9549 11.6015 10.9939 11.4796 11.1144L10.7179 11.8761C10.4792 12.1148 10.11 12.165 9.81651 11.9981C8.19705 11.0773 6.85553 9.73673 5.93467 8.11728C5.76779 7.82379 5.81802 7.45465 6.05674 7.21591L6.81553 6.45713C6.93905 6.33222 6.97855 6.14669 6.91612 5.98056C6.69321 5.3832 6.53858 4.76204 6.45616 4.13681C6.42437 3.91335 6.23174 3.74789 6.00596 3.75009H4.2003Z"
                              fill="#587E85"
                            />
                          </svg>
                          <span> {user?.contactNumber} </span>
                        </a>
                      </Text>
                    )}
                    {userOffice && (
                      <div className={styles["user-list"]}>
                        <svg
                          width="18"
                          height="18"
                          viewBox="0 0 18 18"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M8.25 7.5H9.75V6H8.25V7.5ZM8.25 10.5H9.75V9H8.25V10.5ZM9.75 15V12H8.25V15H6V5.25H8.25H9.75H12V15H9.75ZM15 13.5V15H13.5V3.75H12H9.75V1.5H8.25V3.75H6H4.5V15H3V13.5H1.5V15V16.5H4.5H6H12H13.5H16.5V15V13.5H15Z"
                            fill="#587E85"
                          />
                        </svg>

                        <MoreTagsFunction
                          value={userOffice}
                          styles={styles.link_new}
                          clickHandler={() => {
                            setInvitePopupOpen(user.id);
                          }}
                          mapFn={(member) => member.name}
                        />

                        {invitePopupOpen === user.id && (
                          <InviteesPopup
                            // position={{
                            //   top: 70,
                            //   right: 0,
                            // }}
                            handleInvitePopupToggle={(e) => {
                              setInvitePopupOpen(null);
                            }}
                            list={userOffice}
                            onlyOfffice
                            isfromBusySlot
                            // showRoleAndOffice={true}
                            // isForEvent={true}
                          />
                        )}
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
        {message && children}
      </div>
      {!message && children}
    </>
  );
};
export default StaffCardView;
